import React, { createContext, useContext, useState } from 'react';

interface CartContextType {
  drawerOpen: boolean;
  openDrawer: () => void;
  closeDrawer: () => void;
  toggleDrawer: () => void;
}

const CartContext = createContext<CartContextType | undefined>(undefined);

export const CartProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  const openDrawer = () => setDrawerOpen(true);
  const closeDrawer = () => setDrawerOpen(false);
  const toggleDrawer = () => setDrawerOpen((prev) => !prev);

  return (
    <CartContext.Provider value={{ drawerOpen, openDrawer, closeDrawer, toggleDrawer }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCartDrawer = () => {
  const context = useContext(CartContext);
  if (context === undefined) {
    throw new Error('useCartDrawer must be used within a CartProvider');
  }
  return context;
};



